import React, {Component, createRef} from 'react'
import styles from './FJPreviewTool.module.less';
import classNames from 'classnames';

import InlineSVG from "react-inlinesvg";

class FJButtonNormalIcon extends Component {
  constructor(props) {
    super(props);
    this.container = createRef();
  }

  render() {
    let {
      icon,
      onClick,
      onMouseUp,
      onMouseDown,
      tooltip,
      className,
      disabled,
    } = this.props;

    let cn = classNames(styles.icon, className, disabled ? styles.disabled : styles.c_cursor);

    return (
      <div className={cn}
           onClick={onClick}
           onMouseDown={onMouseDown}
           onMouseUp={onMouseUp}
           tooltip={tooltip}
      >
        <InlineSVG src={icon}/>
      </div>
    );
  }
}

export default FJButtonNormalIcon;
